<template>
    <v-container fluid>
        <v-row  >
            <v-col cols="12" sm="12" md="6" class="case-card">
                <v-card>
                    <v-card-text class="text--primary">
                        <v-progress-linear v-if="progress('getEditedCase')"
                                           indeterminate></v-progress-linear>
                        <case-form v-if="editedCase"
                                   :case="editedCase"
                                   ref="case-update-form"
                                   @init="handleCaseFormInit"
                                   @validation-changed="handleFormValidationChanged"
                        ></case-form>
                        <confirm ref="confirm"></confirm>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary"
                               v-if="editedCase"
                               class="ml-3"
                               :loading="progress('updateCase')"
                               :disabled="!createButtonActive"
                               @click="handleUpdateButtonClick">
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="case-card">
                <v-card>
                    <v-card-text class="text--primary">
                        <b>Reports</b>
                        <v-progress-linear v-if="progress('getEditedCase')"
                                           indeterminate
                        ></v-progress-linear>
                        <reports-manager ref="reportsManager"
                                         v-if="editedCase"
                                         :reports="editedCase.reports || []"
                                         :caseData="editedCase"
                                         :caseUnsavedChangesChecker="checkCaseUnsavedChanges"
                                         @create-report="handleCreateReport"
                                         @update-report="handleUpdateReport">
                        </reports-manager>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import {mapState, mapActions, mapGetters} from 'vuex'
    import _ from 'lodash'
    import CaseForm from '../Components/CaseForm'
    import ReportsManager from '../../Reports/Manager'
    import Confirm from '../../Common/Confirm'

    export default {
        name: 'UpdateCase',
        props: {
          caseSystemId: {
              type: String
          }
        },
        components: {
            Confirm,
            CaseForm,
            ReportsManager
        },
        data () {
            return {
                originalCaseData: null,
                formValid: false,
            }
        },
        async beforeRouteLeave (to, from, next) {
            const caseChanged = this.checkCaseUnsavedChanges()

            let caseNext = true
            let reportNext = true

            if (caseChanged) {
                await this.$refs.confirm.open('Unsaved case changes', `You have unsaved case changes. Do you really want to leave?`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        caseNext = false
                    }
                })
            }

            const reportChanged = this.$refs['reportsManager'].checkCurrentReportUnsavedChanges()

            if (reportChanged) {
                await this.$refs.confirm.open('Unsaved report changes', `You have unsaved report changes. Do you really want to leave?`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        reportNext = false
                    }
                })
            }

            if (caseNext && reportNext) {
                next()

                return
            }

            next(false)
        },
        computed: {
            ...mapGetters('pgtCases', {
                progress: 'progress',
                reportSampleTemplatesById: 'reportSampleTemplatesById'
            }),
            ...mapState('pgtCases', {
                editedCase: 'editedCase'
            }),
            createButtonActive () {
                return this.formValid && !this.progress('updateCase')
            }
        },
        methods: {
            ...mapActions('pgtCases', {
                resetEditedCase: 'resetEditedCase',
                initEditedCase: 'initEditedCase',
                updateCase: 'updateCase',
                createReport: 'createReport',
                updateReport: 'updateReport'
            }),
            handleFormValidationChanged (value) {
                this.formValid = value
            },
            async handleUpdateButtonClick () {
                // setTimeout нужен для решения "blur-проблемы" у комбобоксов
                // https://github.com/vuetifyjs/vuetify/issues/4679
                setTimeout(async () => {
                    const caseData = this.$refs['case-update-form'].getFormData()
                    const updatedCase = await this.updateCase(caseData)

                    if (updatedCase) {
                        this.$router.push(`/cases/pgt/update/${updatedCase.systemId}`)
                    }
                })
            },
            handleCreateReport (report) {
                this.createReport(report)
            },
            handleUpdateReport (report) {
                this.updateReport(report)
            },
            handleCaseFormInit(data) {
                this.originalCaseData = _.cloneDeep(data)
            },
            checkCaseUnsavedChanges() {
                if (!this.$refs['case-update-form']) {
                    return false
                }

                const caseData = this.$refs['case-update-form'].getFormData()
                return !_.isEqual(this.originalCaseData, caseData)
            }
        },
        mounted () {
            this.initEditedCase(this.caseSystemId)
        },
        destroyed() {
            this.resetEditedCase()
        }
    }
</script>

<style scoped>
    .case-card {
        padding: 5px;
    }
</style>